// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1nT0o","search":"Settings_search__39MxQ","filter":"Settings_filter__2a7o4"};